"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconSnowPressureFilled = function IconSnowPressureFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.39,37.73l-.66-.38.57-.08a.81.81,0,0,0,.4-.18.87.87,0,0,0,.32-.8.89.89,0,0,0-1-.73l-2.31.36-.29,0-.23-.13-2.38-1.37-.1-.06a2.6,2.6,0,0,0,0-1l.1-.06,2.37-1.37.23-.13.3,0,2.31.35a.87.87,0,0,0,1-.72.86.86,0,0,0-.71-1l-.58-.08.67-.39a.86.86,0,0,0-.86-1.48l-.66.38.21-.54a.8.8,0,0,0,.05-.43.86.86,0,0,0-1.65-.19l-.85,2.18-.11.27-.23.13-2.38,1.38-.08.05a2.69,2.69,0,0,0-.44-.31,2.62,2.62,0,0,0-.48-.22V28.13l.18-.24,1.47-1.82a.87.87,0,0,0-.14-1.2.88.88,0,0,0-1.21.12l-.35.46v-.77a.86.86,0,0,0-1.72,0v.77L23.78,25a.88.88,0,0,0-1.21-.12.87.87,0,0,0-.13,1.2l1.46,1.82.18.24v3.12a2.71,2.71,0,0,0-.9.52L20.7,30.34l-.22-.13-.11-.27-.85-2.18a.86.86,0,0,0-1.65.19.79.79,0,0,0,.05.43l.21.54-.67-.39A.86.86,0,0,0,16.6,30l.67.39-.57.08a.81.81,0,0,0-.4.18.85.85,0,0,0-.31.8.87.87,0,0,0,1,.72l2.31-.35.29-.05.23.14,2.48,1.42a2.65,2.65,0,0,0,0,1l-2.48,1.43-.22.13-.3,0L17,35.57a.85.85,0,0,0-1,.71.82.82,0,0,0,.31.8.67.67,0,0,0,.4.18l.57.09-.67.38a.87.87,0,0,0-.31,1.18.85.85,0,0,0,1.17.31l.66-.38-.2.53a.75.75,0,0,0-.05.44.84.84,0,0,0,.54.67.86.86,0,0,0,1.1-.48l.86-2.18.1-.27.23-.14L23.17,36a3.36,3.36,0,0,0,.43.31,2.5,2.5,0,0,0,.48.21v3.12l-.18.23-1.46,1.83a.87.87,0,0,0,.13,1.2.85.85,0,0,0,.85.12.7.7,0,0,0,.36-.25l.36-.45v.77a.86.86,0,0,0,1.72,0v-.77l.35.45a.7.7,0,0,0,.36.25.85.85,0,0,0,.85-.12.87.87,0,0,0,.14-1.2l-1.47-1.83-.18-.24V36.5a2.76,2.76,0,0,0,.91-.52l.1.06,2.37,1.37.23.13.12.28L30.48,40a.86.86,0,0,0,1.11.48.84.84,0,0,0,.54-.67.93.93,0,0,0,0-.44l-.22-.53.66.38a.86.86,0,1,0,.86-1.49Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.47,27.41a1.07,1.07,0,0,1-1,.65H35.67a2.24,2.24,0,0,0-.13-.27,3,3,0,0,0-1.79-1.38,3,3,0,0,0-3.89-.95,3,3,0,0,0-1.09-2.23,3.09,3.09,0,0,0-1.68-.67A3,3,0,0,0,25,21.71a3,3,0,0,0-2.1.85,3.07,3.07,0,0,0-1.66.66,3,3,0,0,0-1.11,2.23,3.08,3.08,0,0,0-1.42-.35,2.83,2.83,0,0,0-1.07.21,2.9,2.9,0,0,0-1.39,1.1,3,3,0,0,0-1.8,1.38,1.31,1.31,0,0,0-.12.27H8.92a1.06,1.06,0,0,1-.9-.49,7.31,7.31,0,0,1-1-3.75,7.41,7.41,0,0,1,7.41-7.41,8,8,0,0,1,.86.05,10.59,10.59,0,0,1,20.13,2.2,6.13,6.13,0,0,1,1.15-.13,6.23,6.23,0,0,1,6.32,5A6.34,6.34,0,0,1,42.47,27.41Z",
    fill: color
  }));
};

IconSnowPressureFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconSnowPressureFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconSnowPressureFilled;
exports.default = _default;